import './FormAnnouncement.css'
import { useTreeStateContext } from '/src/features/editor/contexts/TreeContext';
import TitleBlock from '../TitleBlock/TitleBlock';
import editorAction from '../../../actions/editorAction';
import binarySearchString from '../../../utils/binarySearchString';
import { BlockAnnouncementDefault } from '../../../data/constant/blocks/BlockAnnouncementDefault';
import { useTreeDispatchContext } from '../../../contexts/TreeContext';
import TextareaAutosize from 'react-textarea-autosize';
import { useBotStateContext } from '../../../contexts/BotContext';
import { useState } from 'react';

function FormAnnouncement({ id }) {

    const cleanInput = (val) => val.replace(/\[/g, '').replace(/\]/g, '');

    const isVariableFind = (val) => {
        if (!val) return false;
        let hasBrackets = val.startsWith("[") && val.endsWith("]");
        val = cleanInput(val);
        return variables.filter(variable => variable.name == val.toLowerCase()).length > 0 && hasBrackets;
    };

    const { variables } = useBotStateContext();
    const { blocks, paths } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ? blocks[indexBlock] : BlockAnnouncementDefault
    const { data } = block;
    const [variableFound, setVariableFound] = useState(isVariableFind(data.message));
    const name = block.name;
    const dispatch = useTreeDispatchContext();

    const { updateBlockData } = editorAction();

    const setTextareaData = (ref) => {
        if (!ref) {
            return null;
        }

        ref.value = data.message
    }

    const onBlur = (e) => {
        const value = e.target.value;
        updateBlockData(id, { message: value, name: name })
    }

    const onChange = (e) => {
        const value = e.target.value;
        setVariableFound(isVariableFind(e.target.value))
        dispatch({ type: 'updateBlockData', payload: { id, data: { message: value } } })
    }
    return (
        <>
            <TitleBlock title="Announcement" titleInput="Annoucement's name" name={name} id={id} key={title} />
            <div className='area-edit'>
                <label className="input_title">Type your announcement : </label>
                <TextareaAutosize ref={(ref) => setTextareaData(ref)} onBlur={onBlur} onChange={onChange} className={'input editor-input title_input ' + (variableFound ? "variables_found_announcement" : "")}  placeholder='Please, wait a moment' minRows={5} />
            </div>
        </>
    )
}

export default FormAnnouncement;